export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betcoinsportsxmb-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betcoinsportsxmb-themeWrapLive" */'./LiveThemeImporter'),
  },
};
